module.exports = __webpack_public_path__ + "static/InfectedPersonsPrefecture_06.dot-b5063967dc3af71475c4e46ef8b2815a.svg";